import { ApdmReviewAction } from '@euler/functions/apdm/reviewDraft';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { FeedActionButton } from '../../common/FeedActionButton';

/** Send (or send the edit), edit, discard: discard in the danger color. */
export const DraftActions = memo(
  ({
    editing,
    blocked,
    canSendEdit,
    onSubmit,
    onEdit,
  }: {
    editing: boolean;
    /** Busy, or the last action failed: nothing until it is refreshed. */
    blocked: boolean;
    /** The edit has words, within the limit. */
    canSendEdit: boolean;
    onSubmit: (action: ApdmReviewAction) => void;
    onEdit: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: rpx(8),
          marginTop: rpx(12),
        }}
      >
        <FeedActionButton
          title={editing ? '编辑后发送' : '发送消息'}
          disabled={blocked || (editing && !canSendEdit)}
          onPress={() =>
            onSubmit(
              editing ? ApdmReviewAction.EditSend : ApdmReviewAction.Send,
            )
          }
        />
        {editing ? null : (
          <FeedActionButton
            title="修改草稿"
            tone="secondary"
            disabled={blocked}
            onPress={onEdit}
          />
        )}
        <FeedActionButton
          title="丢弃草稿"
          tone="danger"
          disabled={blocked}
          onPress={() => onSubmit(ApdmReviewAction.Discard)}
        />
      </View>
    );
  },
);
